import React from 'react';

import styles from './DisableEventBox.module.css';

const DisableEventBox = () => {
  return <div className={styles.box}></div>;
};

export default DisableEventBox;
